/*
 * Rainbow Cammo — rewards panel triggers
 *
 * The Smile.io floating launcher is hidden (see rc-theme.css). Instead we open
 * the Smile rewards panel on demand from our own inline entry points. Any
 * element with a `data-rc-rewards` attribute becomes a trigger; its value is an
 * optional Smile deep link (e.g. "home", "points_products",
 * "points_activity_rules", "referral_program_details"). Defaults to "home".
 *
 * This store runs Smile's free/"lite" build, which does NOT expose the
 * `SmileUI.openPanel()` JavaScript API. It does honor Smile's supported
 * "anchor tag" deep links, so we open the panel by setting the URL hash
 * (e.g. `#smile-home`). Smile listens for `hashchange`, so we always force a
 * fresh hashchange — otherwise clicking the same trigger twice (open, close,
 * reopen) would be a no-op because the hash wouldn't change.
 *
 * Docs: https://dev.smile.io/ui/panel/deep-links (anchor tag method)
 */
(function () {
  'use strict';

  function openRewards(deepLink) {
    var link = deepLink && deepLink.trim() ? deepLink.trim() : 'home';
    var hash = 'smile-' + link.replace(/_/g, '-');

    // Clear any existing hash without firing an event, then set ours so a
    // hashchange always fires (makes repeat opens reliable).
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    window.location.hash = hash;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rc-rewards]');
    if (!trigger) return;

    event.preventDefault();
    openRewards(trigger.getAttribute('data-rc-rewards'));
  });
})();
